import axios from 'axios'
import { getApiBaseUrl } from '../utils/api'

/**
 * GET /company/franchise/usage is authenticated with X-API-KEY, not the
 * Bearer token the shared `api` instance attaches automatically. The mobile
 * session token IS a company API token already (see MobileAuthContext), so
 * it's reused as-is here - just sent as X-API-KEY instead of Authorization.
 *
 * A dedicated axios call (not the shared `api` instance) on purpose: that
 * instance force-logs-out the session on any 401, and a missing/invalid
 * X-API-KEY here has nothing to do with the mobile session being invalid.
 */
export const franchiseService = {
  getUsage: async (apiKey) => {
    if (!apiKey) throw new Error('Token não disponível')
    const response = await axios.get(`${getApiBaseUrl()}/company/franchise/usage`, {
      headers: { 'X-API-KEY': apiKey },
      timeout: 12000,
    })
    return response.data
  },
}
